import ReturnOrder from "../features/return/ReturnOrder";

const OrderReturn = () => {
  return <ReturnOrder />;
};

export default OrderReturn;
